import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';

import Header from './header';
import Footer from './footer';
import Mediaart from './Mediaart_specific';
import Generatearts from './generate_arts'; // 修正: 正しいファイルからインポート

import './App.css';

function Home({ homeRef, aboutRef, contentsRef }) {
  const location = useLocation();
  const p5ContainerRef = useRef(null);
  let p5Instance = useRef(null);

  // 背景色を管理する状態
  const [backgroundColor, setBackgroundColor] = useState('#e0e0e0');

  // 背景色を管理する状態
  const [textColor, settextolor] = useState('#000000');

  useEffect(() => {
    // 時間帯に応じて背景色を設定
    const updateBackgroundColor = () => {
      const currentHour = new Date().getHours();
      settextolor("#000000");
      if (currentHour >= 6 && currentHour < 12) {
        setBackgroundColor('#FFFAE3'); // 朝: 薄い黄色
      } else if (currentHour >= 12 && currentHour < 16) {
        setBackgroundColor('#FFFFFF'); // 昼: 白
      } else if (currentHour >= 16 && currentHour < 19) {
        setBackgroundColor('#FFDAB9'); // 夕方: 薄いオレンジ
      } else {
        setBackgroundColor('#2C3E50'); // 夜: 紺色
        settextolor("#FFFFFF");
      }
    };

    // 初回実行
    updateBackgroundColor();

    // 1時間ごとに背景色を更新
    const interval = setInterval(updateBackgroundColor, 60 * 60 * 1000);

    return () => clearInterval(interval); // クリーンアップ
  }, []);

  useEffect(() => {
    // ページ遷移時にトップへスクロール
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    // p5.jsのスケッチを適用
    const initializeSketch = () => {
      if (window.sketch && p5ContainerRef.current && !p5Instance.current) {
        p5Instance.current = new window.p5(window.sketch, p5ContainerRef.current);
      }
    };

    if (!document.getElementById('p5-script')) {
      const script = document.createElement('script');
      script.id = 'p5-script';
      script.src = '/mediaarts/basic1.js'; // basic1.js のパス
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        initializeSketch();
      };
    } else {
      initializeSketch();
    }

    return () => {
      if (p5Instance.current) {
        p5Instance.current.remove();
        p5Instance.current = null;
      }
    };
  }, []);

  let text = `Interactive Anywhere Lab略してIALは
Loading Leavesが提供する
インタラクティブアートコンテンツです！
ここでのアートは、いつでもどこでもスマホPCなどで
触れることができます！
例えば大行列で長時間待っているとしましょう。
そんな時は暇つぶしで非現実世界に入りましょう！！！！`;

  const links = [
    { to: "/mediaart?script=basic1.js", imgSrc: "./mediaarts/thumbnail/basic1.png", text: "ランダムパーティクル" },
    { to: "/mediaart?script=basic2.js", imgSrc: "./mediaarts/thumbnail/basic2.png", text: "インクスロー" },
    { to: "/mediaart?script=basic3.js", imgSrc: "./mediaarts/thumbnail/basic3.png", text: "ホイールスピン" },
    { to: "/mediaart?script=basic4.js", imgSrc: "./mediaarts/thumbnail/basic4.png", text: "サウンドパーティクル" },
    // { to: "/mediaart?script=basic5.js", imgSrc: "./mediaarts/thumbnail/basic5.png", text: "サウンドパーティクル2" },
    { to: "/mediaart?script=basic6.js", imgSrc: "./mediaarts/thumbnail/basic6.png", text: "バウンドショット！！！" },
    { to: "/mediaart?script=basic7.js", imgSrc: "./mediaarts/thumbnail/basic7.png", text: "桜クション！" },
    { to: "/mediaart?script=basic9.js", imgSrc: "./mediaarts/thumbnail/basic9.png", text: "Gazing Balls!" },
  ];

  let contact_text = `インタラクティブアートの依頼や
  質問などがあれば
  Loading Leavesのお問い合わせフォームまで
  お願いします！`;

  return (
    <>
      <div ref={homeRef} style={{ width: '100%', height: '140%', padding: '20px', backgroundColor: backgroundColor, boxSizing: 'border-box', overflow: 'hidden' }}>
        <h1 style={{ color: textColor }}>Interactive Anywhere Labへようこそ</h1>
        <p style={{ color: textColor }}>ネットで楽しめるみんなの美術館</p>
        <p style={{ color: textColor }}>作品に触れてみてください！</p>
        <div ref={p5ContainerRef} id="p5-container" style={{ height: '100%', width: '100%' }}></div>
      </div>

      <div ref={aboutRef} style={{
        height: '80%', padding: '20px', backgroundColor: backgroundColor,
        boxSizing: 'border-box'
      }}>
        <h2 style={{ color: textColor }}>About Us</h2>
        <p className="text" style={{ color: textColor }}>{text}</p>
        <h2 style={{ color: textColor }}>ここに注目！</h2>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          boxSizing: 'border-box',
          maxWidth: '100%',
          justifyContent: 'center',
          overflow: 'hidden',
        }}>
          <div>
            <img src="./promo/1.png" style={{ width: '80%', borderRadius: '10px' }} />
            <p style={{ color: textColor }}><strong>時間によって背景が変わります！</strong></p>
          </div>
          <div>
            <img src="./promo/2.png" style={{ width: '80%', borderRadius: '10px' }} />
            <p style={{ color: textColor }}><strong>タップや音声であそべます！</strong></p>
          </div>

        </div>
      </div>

      <div ref={contentsRef} style={{ height: '80%', padding: '20px', backgroundColor: backgroundColor, boxSizing: 'border-box' }}>
        <h2 style={{ color: textColor }}>Enjoy the Contents!</h2>
        <p style={{ color: textColor }}>ここではコンテンツを楽しむことができます。</p>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          maxWidth: '100%',
          justifyContent: 'center',
          overflow: 'hidden',
        }}>
          {links.map((link, index) => (
            <div style={{ backgroundColor: '#ee82ee', padding: '10px', borderRadius: '10px' }} key={index}>
              <Link to={link.to} style={{ color: 'black', width: '400px', textAlign: 'center' }}>
                <img src={link.imgSrc} alt={link.text} style={{ width: '350px' }} />
                <p><strong>{link.text}</strong></p>
              </Link>
            </div>
          ))}
        </div>
      </div>

      <div ref={contentsRef} style={{ height: '80%', padding: '20px', backgroundColor: backgroundColor }}>
        <h2 style={{ color: textColor }}>お問い合わせ</h2>
        <p className="text" style={{ color: textColor }}>{contact_text}</p>
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLScclkj2NVbcbSYWIp8cseWV8iVLCUdJDkT24nJdYZzWD2hvpg/viewform"
          target="_blank"
          rel="noopener noreferrer"
          className="contactbutton"

        >
          お問い合わせはコチラ
        </a>
      </div>
    </>
  );
}

function App() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const contentsRef = useRef(null);

  const scrollToSection = (ref) => {
    ref.current.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header
        scrollToSection={scrollToSection}
        homeRef={homeRef}
        aboutRef={aboutRef}
        contentsRef={contentsRef}
      />

      <Routes>
        <Route path="/" element={<Home homeRef={homeRef} aboutRef={aboutRef} contentsRef={contentsRef} />} />
        <Route path="/mediaart" element={<Mediaart />} />
        <Route path="/generatearts" element={<Generatearts />} />
      </Routes>
      <Footer />

    </div>
  );
}

export default App;